/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-documents
 * crm-screener-documents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 'pending'/'generating' only appear on documents generated through the
 * asynchronous enqueue endpoint — the synchronous GenerateReport
 * endpoint never returns a record until generation has already
 * succeeded, so it's always 'completed' there.
 * 
 * @export
 */
export const ScreenerGeneratedDocumentStatus = {
    Pending: 'pending',
    Generating: 'generating',
    Completed: 'completed',
    Failed: 'failed',
} as const;
export type ScreenerGeneratedDocumentStatus = typeof ScreenerGeneratedDocumentStatus[keyof typeof ScreenerGeneratedDocumentStatus];


export function instanceOfScreenerGeneratedDocumentStatus(value: any): boolean {
    for (const key in ScreenerGeneratedDocumentStatus) {
        if (Object.prototype.hasOwnProperty.call(ScreenerGeneratedDocumentStatus, key)) {
            if (ScreenerGeneratedDocumentStatus[key as keyof typeof ScreenerGeneratedDocumentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScreenerGeneratedDocumentStatusFromJSON(json: any): ScreenerGeneratedDocumentStatus {
    return ScreenerGeneratedDocumentStatusFromJSONTyped(json, false);
}

export function ScreenerGeneratedDocumentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerGeneratedDocumentStatus {
    return json as ScreenerGeneratedDocumentStatus;
}

export function ScreenerGeneratedDocumentStatusToJSON(value?: ScreenerGeneratedDocumentStatus | null): any {
    return value as any;
}

export function ScreenerGeneratedDocumentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ScreenerGeneratedDocumentStatus {
    return value as ScreenerGeneratedDocumentStatus;
}

